import React from 'react';

/** Curly “…” or straight "..." pairs used as quotation marks in CMS copy. */
const QUOTED_PHRASE_RE = /\u201C([^\u201D]+)\u201D|"([^"]+)"/g;

/**
 * Wrap quoted phrases in <q> for accessibility, without touching HTML
 * attribute quotes (e.g. iframe src="..." / width="640").
 */
export function wrapSemanticQuotesInMarkup(text) {
  if (!text || typeof text !== 'string') return text;

  const tags = [];
  const withoutTags = text.replace(/<[^>]+>/g, (tag) => {
    const token = `\0TAG${tags.length}\0`;
    tags.push(tag);
    return token;
  });

  const wrapped = withoutTags.replace(
    QUOTED_PHRASE_RE,
    (_, curly, straight) => `<q>${curly || straight}</q>`,
  );

  return wrapped.replace(/\0TAG(\d+)\0/g, (_, index) => tags[Number(index)]);
}

export function renderTextWithSemanticQuotes(text) {
  if (!text || typeof text !== 'string') return text;

  const parts = [];
  let lastIndex = 0;
  let match;
  let key = 0;
  const re = new RegExp(QUOTED_PHRASE_RE.source, 'g');

  while ((match = re.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(<q key={`q-${key++}`}>{match[1] || match[2]}</q>);
    lastIndex = re.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return key === 0 ? text : parts;
}
